import React, { useContext } from 'react';
import styled, { ThemeContext } from 'styled-components';
import { Image } from '../Image';
import { isCurrentSite, isFieldValid } from '../../utils/validation';
import { NavigationLink } from '../Link';
import { Icon } from '../Icon';
import { UnstyledButton } from '../Buttons';
import { getSiteName, getFieldValue } from '../../utils/helpers';
import media from '../../utils/media';
import { populateNavigationGTM } from '../../utils/gtm';
const Nav = styled.nav `
  width: 100%;
`;
const LabelContainer = styled.div `
  margin-left: 11px;
`;
const StyledImage = styled(Image) `
  display: block;
  width: 48px;
  object-fit: contain;
  height: 24px;
  margin-left: 10px;
  object-position: left;
`;
export const VerticalNavigationContainer = styled.ul `
  display: flex;
  list-style: none;
  margin: 0;
  padding-left: 0;
  list-style: none;
  padding-left: 0px;
  margin: 0;
  width: 320px;
  background: ${({ theme }) => theme.primaryWhite};
  box-shadow: none;
  flex-direction: column;
  ${media.smallDesktop} {
    box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.2);
  }
  ${media.tablet} {
    width: auto;
    height: calc(100vh - 51px);
    box-shadow: none;
  }
`;
const ItemContainer = styled.li `
  width: calc(100% - 48px);
  ${media.tablet} {
    width: calc(100% - 20px);
  }
  padding: 0px 13px 0px 15px;
  height: 54px;

  border-bottom: 1px solid ${({ theme }) => theme.greyLight};
  position: relative;
  margin: 0px 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  &:last-child {
    border-bottom: 1px solid ${({ theme }) => theme.primaryWhite};
  }

  ${media.tablet} {
    &:last-child {
      border-bottom: 1px solid ${({ theme }) => theme.greyLight};
    }
  }
`;
const ButtonContainer = styled(UnstyledButton) `
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
export const StyledLabel = styled.span `
  margin-left: 11px;
  border: none;
  background: none;
  padding: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  cursor: pointer;
  outline: none;
  font-style: normal;
  font-size: 16px;
  line-height: 24px;
  color: ${({ theme }) => theme.primaryBlack};
  font-family: ${({ theme }) => theme.fontFamilyBold};
  font-size: 16px;
  line-height: 24px;
  &:hover {
    color: ${({ theme }) => theme.primaryRed};
  }

  ${media.mobile} {
    line-height: 22px;
    font-size: 14px;
  }
`;
const StyledIcon = styled(Icon) `
  font-size: 35px;
  transform: rotate(270deg);
`;
// indicator of Siteowner
const SiteIndicator = styled.div `
  position: absolute;
  height: 55px;
  width: 10px;
  background-color: ${({ theme }) => theme.primaryRed};
  left: -10px;
  top: 0px;
  display: ${({ isHighlighted }) => (isHighlighted ? 'block' : 'none')};
`;
export const VerticalNavigation = ({ currentSite, setChildMenuData, setChildMenuLabel, setChildMenuToOpen, navigationItems, siteOwner, navigationType, currentLanguage, allowContentToBeTabable, onClose }) => {
    if (!navigationItems) {
        return null;
    }
    const themeContext = useContext(ThemeContext) || {};
    const { isWindowMobile } = themeContext;
    return (React.createElement(Nav, { "aria-label": navigationType ? navigationType : 'primary-navigation' },
        React.createElement(VerticalNavigationContainer, null, navigationItems.map(({ fields }, index) => {
            // renders child nav with clickable text
            const { label, url, items, icon, notVisible, siteOwner: navSiteOwner } = fields;
            // by default, notVisible value is false
            // if true, do not render
            if (isFieldValid(notVisible)) {
                return null;
            }
            if (items && label && label.value) {
                return (React.createElement(ItemContainer, { key: index.toString(), isWindowMobile: !!isWindowMobile },
                    React.createElement(ButtonContainer, { onClick: () => {
                            if (setChildMenuData && setChildMenuLabel) {
                                setChildMenuData(items);
                                setChildMenuLabel(label.value);
                                if (setChildMenuToOpen)
                                    setChildMenuToOpen();
                            }
                        } },
                        React.createElement(StyledLabel, null, label.value),
                        React.createElement(StyledIcon, null, "arrow_drop_down"))));
            }
            // renders normal link
            else if (label && url && url.value) {
                let siteName = getSiteName(url);
                siteName = siteName === '' ? (currentLanguage.startsWith('en') ? 'home' : 'accueil') : siteName;
                const navSiteOwnerName = getFieldValue(navSiteOwner);
                const { text: ariaLabel } = url.value;
                return (React.createElement(ItemContainer, { key: index.toString(), isWindowMobile: !!isWindowMobile, onClick: onClose },
                    React.createElement(SiteIndicator, { isHighlighted: navigationType === 'secondary-navigation'
                            ? isCurrentSite(siteOwner, navSiteOwnerName)
                            : isCurrentSite(currentSite, siteName) }),
                    React.createElement(NavigationLink, Object.assign({ tabIndex: allowContentToBeTabable ? 0 : -1, to: `${siteName}`, external: url.value.linktype === 'external', href: url.value.href, navigationType: navigationType, target: url.value.target, ariaLabel: ariaLabel }, populateNavigationGTM(fields)),
                        isFieldValid(icon) && React.createElement(StyledImage, { media: icon }),
                        React.createElement(LabelContainer, null, label.value))));
            }
            else {
                // value is falsey
                return null;
            }
        }))));
};
